import { CALL_AUTHORIZATION_MANAGEMENT_API } from '../../middleware/authHeaders'
import { AUTHORIZATION_MANAGEMENT_API_ROOT } from '../../config/api'

export const AUTHORIZATION_SEARCH_CONTEXT_REQUEST = 'AUTHORIZATION_SEARCH_CONTEXT_REQUEST'
export const AUTHORIZATION_SEARCH_CONTEXT_SUCCESS = 'AUTHORIZATION_SEARCH_CONTEXT_SUCCESS'
export const AUTHORIZATION_SEARCH_CONTEXT_FAILURE = 'AUTHORIZATION_SEARCH_CONTEXT_FAILURE'

export const searchAuthorizationContext =
  (searchText, applicationId, pageNumber = 1, pageSize = 20) =>
  dispatch => {
    return dispatch({
      [CALL_AUTHORIZATION_MANAGEMENT_API]: {
        method: 'GET',
        endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/search?applicationId=${applicationId}&searchText=${searchText}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        types: [
          AUTHORIZATION_SEARCH_CONTEXT_REQUEST,
          AUTHORIZATION_SEARCH_CONTEXT_SUCCESS,
          AUTHORIZATION_SEARCH_CONTEXT_FAILURE,
        ],
      },
    })
  }

export const AUTHORIZATION_GET_CONTEXT_REQUEST = 'AUTHORIZATION_GET_CONTEXT_REQUEST'
export const AUTHORIZATION_GET_CONTEXT_SUCCESS = 'AUTHORIZATION_GET_CONTEXT_SUCCESS'
export const AUTHORIZATION_GET_CONTEXT_FAILURE = 'AUTHORIZATION_GET_CONTEXT_FAILURE'

export const getAuthorizationContext = contextId => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'GET',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}`,
      types: [
        AUTHORIZATION_GET_CONTEXT_REQUEST,
        AUTHORIZATION_GET_CONTEXT_SUCCESS,
        AUTHORIZATION_GET_CONTEXT_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_CREATE_CONTEXT_ROLE_REQUEST = 'AUTHORIZATION_CREATE_CONTEXT_ROLE_REQUEST'
export const AUTHORIZATION_CREATE_CONTEXT_ROLE_SUCCESS = 'AUTHORIZATION_CREATE_CONTEXT_ROLE_SUCCESS'
export const AUTHORIZATION_CREATE_CONTEXT_ROLE_FAILURE = 'AUTHORIZATION_CREATE_CONTEXT_ROLE_FAILURE'

export const createAuthorizationContextRole = (contextId, role) => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'POST',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/roles`,
      body: JSON.stringify(role),
      types: [
        AUTHORIZATION_CREATE_CONTEXT_ROLE_REQUEST,
        AUTHORIZATION_CREATE_CONTEXT_ROLE_SUCCESS,
        AUTHORIZATION_CREATE_CONTEXT_ROLE_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_DELETE_CONTEXT_ROLE_REQUEST = 'AUTHORIZATION_DELETE_CONTEXT_ROLE_REQUEST'
export const AUTHORIZATION_DELETE_CONTEXT_ROLE_SUCCESS = 'AUTHORIZATION_DELETE_CONTEXT_ROLE_SUCCESS'
export const AUTHORIZATION_DELETE_CONTEXT_ROLE_FAILURE = 'AUTHORIZATION_DELETE_CONTEXT_ROLE_FAILURE'

export const deleteAuthorizationContextRole = (contextId, roleId) => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'DELETE',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/roles/${roleId}`,
      types: [
        AUTHORIZATION_DELETE_CONTEXT_ROLE_REQUEST,
        AUTHORIZATION_DELETE_CONTEXT_ROLE_SUCCESS,
        AUTHORIZATION_DELETE_CONTEXT_ROLE_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_UPDATE_CONTEXT_ROLE_REQUEST = 'AUTHORIZATION_UPDATE_CONTEXT_ROLE_REQUEST'
export const AUTHORIZATION_UPDATE_CONTEXT_ROLE_SUCCESS = 'AUTHORIZATION_UPDATE_CONTEXT_ROLE_SUCCESS'
export const AUTHORIZATION_UPDATE_CONTEXT_ROLE_FAILURE = 'AUTHORIZATION_UPDATE_CONTEXT_ROLE_FAILURE'

export const updateAuthorizationContextRole = (contextId, roleId, payload) => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'PATCH',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/roles/${roleId}`,
      body: JSON.stringify(payload),
      types: [
        AUTHORIZATION_UPDATE_CONTEXT_ROLE_REQUEST,
        AUTHORIZATION_UPDATE_CONTEXT_ROLE_SUCCESS,
        AUTHORIZATION_UPDATE_CONTEXT_ROLE_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_SET_CONTEXT = 'AUTHORIZATION_SET_CONTEXT'
export const setAuthorizationContext = context => ({
  type: AUTHORIZATION_SET_CONTEXT,
  payload: context,
})

const selectAuthorizationContextsSlice = state =>
  state.authorizationManagement.authorizationContexts

export const selectSelectedAuthorizationContext = state =>
  selectAuthorizationContextsSlice(state).selectedContext

const initialState = {
  selectedContext: null,
  fetchedContext: null,
}

// REDUCERS
const authorizationContexts = (state = initialState, { type, payload } = {}) =>
  ({
    [AUTHORIZATION_GET_CONTEXT_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      fetchedContext: newPayload,
    }),
    [AUTHORIZATION_CREATE_CONTEXT_ROLE_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedContext: {
        ...currentState.selectedContext,
        roles: { ...currentState.selectedContext.roles, [newPayload.id]: newPayload },
      },
    }),
    [AUTHORIZATION_DELETE_CONTEXT_ROLE_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedContext: newPayload,
    }),
    [AUTHORIZATION_UPDATE_CONTEXT_ROLE_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedContext: {
        ...currentState.selectedContext,
        roles: { ...currentState.selectedContext.roles, [newPayload.id]: newPayload },
      },
    }),
    [AUTHORIZATION_SET_CONTEXT]: (currentState, newPayload) => ({
      ...currentState,
      selectedContext: newPayload,
    }),
  }[type]?.(state, payload) || state)

export default authorizationContexts
